module.exports = __webpack_public_path__ + "VAGRoundedStd-Bold.21679b58e2614c0c16c5.woff";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Bold.woff
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Bold.woff
// module chunks = styles